export const Globals = {
  crm_api_server_endpoint: "/api/",
  socketio_server_addr: "/",
  viki_server_addr: "/viki/",

  joomla_website: "https://www.toolstrades.com/",
  cms: {
    sms_power_signals: false,
    signals_stats: false,
    change_plan: false,
    change_password: false
  },
  click_2_call_url: "https://click2call.pbx.commpeak.com/call/2/78/",
  backup_click_2_call_url: "https://gnmmedia.odricall.com/custom/click2call?username=",
  first_owner_id: 41,
  second_owner_id: 56,
  dep_task_cat_id: 30,
  owners_emails: [
    "guy@media-gnm.com",
    "mike@media-gnm.com",
    "admin@gnm-crm.local"
  ],
  ux: {
    section: {
      top_tag_menu: {
        cal_presets_speed: 250
      }
    }
  }
};
